<template>
  <div id="notFound">
    <div class="text-center col-sm-12">
      <h1>Esta página no existe</h1>
      <router-link to="/" class="vertical-5p lead">Ir al inicio.</router-link>
    </div>
  </div>
</template>
<script>
export default {
  name: 'NotFound'
}
</script>

<style>
 
</style>



// WEBPACK FOOTER //
// 404.vue?3d2b7952